/**
 * useChatbotContext Hook
 *
 * Re-exports the canonical hook from ChatbotProvider to provide
 * an alternative import path without circular dependencies.
 */

export { useChatbotContext } from '../providers/ChatbotProvider';
